export default __webpack_public_path__ + "f42d258.png";